<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template lang="html">

  <section class="login">
    <h1>Login Component</h1>
    <p>{{ $route.query }}</p>
    <p>{{ $route.query.token }}</p>
    <p>{{ $route.query.exp }}</p>
    <p v-if="stored">
      Token stored
    </p>
  </section>

</template>

<script lang="js">
import { mapActions, mapState, mapGetters } from 'vuex';
// import moment from 'moment';
import get from 'lodash.get';
// import includes from 'lodash.includes';
import slugify from 'slugify';

export default {
  name: 'login',
  props: [],
  mounted() {
    this.$log.info(JSON.stringify(this.$route.query, null, 2));
    if (this.$route.query && this.$route.query.status && this.$route.query.status === 'success') {
      const exp = get(this, '$route.query.exp'); // this.$route.query.exp
      const ad = {
        token: this.$route.query.token,
        exp,
      };

      const now = Math.floor(new Date().getTime() / 1000);
      const tokenDurationSec = Math.floor(exp - now);
      this.$cookies.set(`${window.TOK_NS}storageAccessData`, ad);
      // this.setCookieInMinutes(`${window.TOK_NS}storageAccessData`, ad, tokenDurationSec / 60);
      this.$ls.set('storageAccessData', ad, tokenDurationSec * 1000);
      this.$ls.remove('availablePlans');
      const tmpHD = this.$ls.get('storageHomeData');
      get(tmpHD, 'category_videos', []).forEach((category) => {
        this.$ls.remove(`cat_${slugify(category.title)}`);
      });
      this.$ls.remove('storageHomeData');
      const that = this;
      this.setLoginInfo(ad)
        .then(() => {
          that.getMe()
            .then(() => {
              if (get(that, 'me.active_offers', false)) {
                window.ga('tok.set', { dimension7: get(that, 'me.active_offers9', []).join(',') });
              }
              if (get(that, 'me.registered', false)) window.ga('tok.send', 'event', 'Registration', 'Registration Completed');
              that.getPlans();
              const event = get(this.$route, 'query.event');
              if (event === 'alleanza') {
                that.$router.push('/ConventionAlleanza2021');
                return;
              }
              if (that.referer || that.$ls.get('referrer')) {
                const referrer = that.$ls.get('referrer') ? that.$ls.get('referrer') : that.referer;
                that.$router.push(referrer);
              } else {
                that.stored = true;
                that.appReady(true);
              }
            })
            .catch((e) => {
              this.$log.error(e);
            });
        })
        .catch((e) => {
          that.$log.error(e);
        });
    } else {
      window.ga('tok.send', 'event', 'Registration', 'Registration Failed');
      this.$router.push('/');
    }
  },
  data() {
    return {
      stored: false,
    };
  },
  methods: {
    ...mapActions(['setLoginInfo', 'appReady', 'getMe', 'getPlans', 'home']),
    setCookieInMinutes(name, value, minutes) {
      const d = new Date();
      d.setTime(d.getTime() + 60 * 1000 * minutes);
      // const cookieString = `${name}=${JSON.stringify(value)};path=/;expires=${d.toGMTString()};SameSite=None;Secure`;
      let cookieString = `${name}=${JSON.stringify(value)};path=/;expires=${d.toGMTString()}`;
      if (this.env === 'prod') {
        cookieString += ';SameSite=None;Secure';
      }
      document.cookie = cookieString;
    },
  },
  computed: {
    ...mapGetters(['getToken']),
    ...mapState(['referer', 'me', 'env', 'conf']),
  },
};
</script>

<style scoped lang="scss">
.login {

}
</style>
